/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Unsubscribe_ResubscribeInputs */

const en_newsletter_unsubscribe_resubscribe = /** @type {(inputs: Newsletter_Unsubscribe_ResubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I changed my mind`)
};

/**
* | output |
* | --- |
* | "I changed my mind" |
*
* @param {Newsletter_Unsubscribe_ResubscribeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_unsubscribe_resubscribe = /** @type {((inputs?: Newsletter_Unsubscribe_ResubscribeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Unsubscribe_ResubscribeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_unsubscribe_resubscribe(inputs)
});